export default "__VITE_ASSET__CALXC0Zk__"